import { render, staticRenderFns } from "./ParametricContentThreadsTabs.vue?vue&type=template&id=02ec6a56&scoped=true&"
import script from "./ParametricContentThreadsTabs.vue?vue&type=script&lang=js&"
export * from "./ParametricContentThreadsTabs.vue?vue&type=script&lang=js&"
import style0 from "./ParametricContentThreadsTabs.vue?vue&type=style&index=0&id=02ec6a56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec6a56",
  null
  
)

export default component.exports